// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    one: `${ROOTS.DASHBOARD}/one`,
    two: `${ROOTS.DASHBOARD}/two`,
    three: `${ROOTS.DASHBOARD}/three`,
    group: {
      root: `${ROOTS.DASHBOARD}/group`,
      five: `${ROOTS.DASHBOARD}/group/five`,
      six: `${ROOTS.DASHBOARD}/group/six`,
    },
    poems: {
      root: `${ROOTS.DASHBOARD}/poems`,
      list: `${ROOTS.DASHBOARD}/poems/list`,
      new: `${ROOTS.DASHBOARD}/poems/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/poems/${id}/edit`,
      view: (id: string) => `${ROOTS.DASHBOARD}/poems/${id}`,
      vttGenerator: `${ROOTS.DASHBOARD}/poems/vtt-generator`,
    },
    poets: {
      root: `${ROOTS.DASHBOARD}/poets`,
      list: `${ROOTS.DASHBOARD}/poets/list`,
      new: `${ROOTS.DASHBOARD}/poets/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/poets/${id}/edit`,
      view: (id: string) => `${ROOTS.DASHBOARD}/poets/${id}`,
    },
    themes: {
      root: `${ROOTS.DASHBOARD}/themes`,
      list: `${ROOTS.DASHBOARD}/themes/list`,
      new: `${ROOTS.DASHBOARD}/themes/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/themes/${id}/edit`,
    },
    tags: {
      root: `${ROOTS.DASHBOARD}/tags`,
      list: `${ROOTS.DASHBOARD}/tags/list`,
      new: `${ROOTS.DASHBOARD}/tags/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/tags/${id}/edit`,
    },
    audios: {
      root: `${ROOTS.DASHBOARD}/audios`,
      list: `${ROOTS.DASHBOARD}/audios/list`,
      new: `${ROOTS.DASHBOARD}/audios/new`,
      edit: (id: number | string | undefined) => `${ROOTS.DASHBOARD}/audios/${id}/edit`,
      view: (id: number | string | undefined) => `${ROOTS.DASHBOARD}/audios/${id}`,
    },
    users: {
      root: `${ROOTS.DASHBOARD}/users`,
      list: `${ROOTS.DASHBOARD}/users/list`,
      new: `${ROOTS.DASHBOARD}/users/new`,
      edit: (id: number | string) => `${ROOTS.DASHBOARD}/users/${id}/edit`,
      view: (id: number | string) => `${ROOTS.DASHBOARD}/users/${id}`,
    },
    singers: {
      root: `${ROOTS.DASHBOARD}/singers`,
      list: `${ROOTS.DASHBOARD}/singers/list`,
      new: `${ROOTS.DASHBOARD}/singers/new`,
      edit: (id: number | string) => `${ROOTS.DASHBOARD}/singers/${id}/edit`,
      view: (id: number | string) => `${ROOTS.DASHBOARD}/singers/${id}`,
    },
    difficultWords: {
      root: `${ROOTS.DASHBOARD}/difficult-words`,
      list: `${ROOTS.DASHBOARD}/difficult-words/list`,
      new: `${ROOTS.DASHBOARD}/difficult-words/new`,
      edit: (id: number | string) => `${ROOTS.DASHBOARD}/difficult-words/${id}/edit`,
      view: (id: number | string) => `${ROOTS.DASHBOARD}/difficult-words/${id}`,
    },
  },
  // DIIWAANU AHLU LAHI
  home: '/',
  poets: '/poets',
  poems: '/poems',
  audios: '/audios',
  statistics: '/statistics',
  poem: (id: string) => `/poem/${id}`,
  poet: (id: string) => `/poet/${id}`,
  audio: (id: number | string) => `/audio/${id}`,
};
